import CTABtn from "components/CTABtn"
import Icon from "components/Icon"
import { Column, Row } from "components/Layout"
import * as gamesAPI from "modules/gamesAPI"
import { useNavigate } from "react-router-dom"
import colors from "styles/colors"
import pkg from "../../../package.json"

export function AboutPage() {
  const navigate = useNavigate()

  return (
    <Column style={{ height: "100%", position: "relative" }}>
      <Row align="ml" padding="0 1rem" gap="1rem" style={{ height: 70 }}>
        <Icon name="arrow-left" onClick={() => navigate(-1)} />
        <h3>About</h3>
      </Row>

      <Column align="mc" style={{ flex: 1 }} gap={24}>
        <img src="/img/logo.svg" alt="Logo" />

        <h5 style={{ color: colors.textMedium }}>Version {pkg.version}</h5>

        <CTABtn
          onClick={() => navigate("/open_source_license")}
          style={{ background: colors.secondary }}
        >
          Licenses
        </CTABtn>
      </Column>

      <Column align="mc" style={{ color: colors.textMedium, height: 70 }}>
        <small>User ID: {gamesAPI.userId()}</small>
        <small>Session ID: {gamesAPI.sessionId()}</small>
      </Column>
    </Column>
  )
}
